<template>
  <div>     
        <div class="contact-tracing-text">Contact Tracing History</div> 
        <!--<div class="contact-tracing-text">Contact Tracing History - Filtered on "{{this.$data.filterText}}"</div>-->

        <DxDataGrid
            ref="detailGridRef"
            :data-source="gridData"
            :paging="{enabled: false}"
            key-exp="LocationId"
            :show-borders="true"
            :selection="{ mode: 'multiple', showCheckBoxesMode: 'never' }"
            @row-prepared="gridRowPrepared"
        >

            <DxColumn
                cell-template="row-checkbox"
                data-field="Selected"
                caption=""
                data-type="boolean"
                :width="80"
            />
            <template #row-checkbox="{ data: row }">
                <div class="row-checkbox">
                    <DxCheckBox
                      :value.sync="row.data.Selected"
                      :onValueChanged="chkSelectedValueChanged"
                    />
                    <!--<DxCheckBox                       
                        :onValueChanged="function(e) {  
                            //Select/deselect the row when the checkbox is clicked.
                            var keys = [];  
                            for (var i = 0; i < row.data.items.length; i++) 
                            { 
                                keys.push(row.data.items[i].KeyField);  
                            }
                            if (e.value)  
                                grid.selectRows(keys, true);  
                            else  
                                grid.deselectRows(keys);  
                        }"
                    />-->                    
                </div>
            </template>


            <!--<DxColumn
                data-field="Selected"
                caption=""
                data-type="boolean"
                :allow-exporting="true"
                :visible="true"
            />-->
            <DxColumn
                data-field="createdOn"
                caption="Date"
                data-type="datetime"
                :allow-exporting="true"
            />
            <DxColumn
                data-field="LocationName"
                caption="Table Name"
                data-type="text"
                :allow-exporting="true"
                :visible="false"
            />
            <DxColumn
                data-field="LocationDescription"
                caption="Description"
                data-type="text"
                :allow-exporting="true"
                :visible="false"
            />
            <DxColumn
                data-field="FirstName"
                caption="First Name"
                data-type="text"
                :allow-exporting="true"
            />
            <DxColumn
                data-field="LastName"
                caption="Last Name"
                data-type="text"
                :allow-exporting="true"
            />
            <DxColumn
                data-field="PhoneNumber"
                caption="Phone"
                data-type="text"
                :allow-exporting="true"
                cell-template="phone-column"
            />
            <DxColumn
                data-field="Email"
                caption="E-mail"
                data-type="text"
                :allow-exporting="true"
            />
            <DxColumn
                data-field="Address"
                caption="Address"
                data-type="text"
                :allow-exporting="true"
            />
            <DxColumn
                data-field="City"
                caption="City"
                data-type="text"
                :allow-exporting="true"
            />
            <DxColumn
                data-field="State"
                caption="State"
                data-type="text"
                :allow-exporting="true"
            />
            <DxColumn
                data-field="ZipCode"
                caption="Postal Code"
                data-type="text"
                :allow-exporting="true"
            />

            <template #phone-column="{ data: row }">
                <div class="temp">
                    {{formatPhoneNumber(row.data.PhoneNumber)}} 
                </div>
            </template>
            
        </DxDataGrid>
  </div>
</template>
<script>

import { DxDataGrid, DxColumn, DxMasterDetail, DxSelection} from 'devextreme-vue/data-grid';
import { DxTextBox, DxButton as DxTextBoxButton } from 'devextreme-vue/text-box';
import DxDateBox from 'devextreme-vue/date-box';
import DxButton from 'devextreme-vue/button';
import adminData from '../../../src/data/admin-data.js';
import shared from '../../utils/contact-tracing-functions';
import DetailTemplate from './admin-related-contacts-detail';
import { DxCheckBox } from 'devextreme-vue/check-box';

//const detailData = service.getNewClientDetailData();

export default {
    components: {
        DxDataGrid,
        DxColumn,
        DxMasterDetail,
        DxTextBox,
        DxButton,
        DxTextBoxButton,
        DxDateBox,
        DetailTemplate,
        DxSelection,
        DxCheckBox,
    },
  props: {
    masterDataSource: null,
    filter: null,
    templateData: {
      type: Object,
      default: ()=>{}
    }
  },
  data() {
    
    return {
      currentRow: null,
      rowIndex: 0,
      //dataSource: this.getDetail(this.templateData.key),
      //gridData: adminData.getAdminHomeTestData()[0].AdminHomeTestRecord[0].rows, 
      gridData: this.masterDataSource,
      filterText: this.filter,
      filterTable: this.templateData.data.LocationName,
      locationId: this.templateData.data.LocationId
    };

  },
  created(){
    //this.$data.dataSource = this.templateData.data.questions;
  },
  mounted(){
    var filterValue = 'Table 2'

    //Filter the data in the grid on the selected Table
    this.$refs.detailGridRef.instance.filter([
        ["LocationName","contains", this.filterTable],
    ]);
  },
  methods: {
    /*
      Format a string as a phone number
    */
    formatPhoneNumber(phoneNumberString) {
      var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
      var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
      if (match) {
        var intlCode = (match[1] ? '+1 ' : '')
        return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
      }
      return null
    },
    chkSelectedValueChanged(e){
      console.log("chkSelectedValueChanged");
    },
    getDetail(key) {
      /*return new DataSource({
        store: new ArrayStore({
          data: detailData,
          key: 'ID'
        }),
        filter: ['TransactionID', '=', key]
      });*/
    },
    onCellClick: function(e) {
      try{

      }
      catch(ex){
        console.log(ex);
      }
    },
    gridRowPrepared(e){
      console.log('gridRowPrepared');

      //If this is a Data row and row.Selected is 1, select the row
      if(e.rowType == 'data'){
        //e.data.Selected
        
        //Select/deselect the row
        var keys = [];  
        /*for (var i = 0; i < e.data.items.length; i++) 
        { 
            keys.push(e.data.items[i].KeyField);  
        }*/

        keys.push(e.key);  

        if (e.data.Selected)  
            this.$refs.detailGridRef.instance.selectRows(keys, true);  
        else  
            this.$refs.detailGridRef.instance.deselectRows(keys);  
      }
      
    }
  }
};

</script>

<style>
  .dx-datagrid-rowsview .dx-master-detail-row:not(.dx-datagrid-edit-form) .dx-master-detail-cell, 
  .dx-datagrid-rowsview .dx-master-detail-row:not(.dx-datagrid-edit-form) > .dx-datagrid-group-spaceaster-detail-row{
      /*background-color: #bed2eb;*/
      background-color: #b8cabd; /*real light green */
  }

  /*Row text*/
  .dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused) > td, .dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused) > tr > td, 
  .dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused):hover > td, 
  .dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused):hover > tr > td{
      /*color:white;*/
  }

  .dx-selection{
      /*background-color: #2653ce;*/
      /*background-color: #147c33;*/    /*Darker green*/
      background-color: #f4f7f5; /*lighter green*/
      /*background-color: #A58E4A;*/
  }

  .contact-tracing-text{
      color:  #147c33; 
      font-weight: bold;
      padding-bottom: 10px;
  }
</style>
